import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CpeContextType {
  nodeId: string;
  cpeName: string;
}

interface CpeProviderProps {
  children: ReactNode;
}

const CpeContext = createContext<{
  cpe: CpeContextType;
  setCpe: React.Dispatch<React.SetStateAction<CpeContextType>>;
} | undefined>(undefined);

export const CpeProvider: React.FC<CpeProviderProps> = ({ children }) => {
  const [cpe, setCpe] = useState<CpeContextType>({ cpeName: '', nodeId: '' });

  return (
    <CpeContext.Provider value={{ cpe, setCpe }}>
      {children}
    </CpeContext.Provider>
  );
};

export const useCpe = () => {
  const context = useContext(CpeContext);
  if (!context) {
    throw new Error('useCpe must be used within a CpeProvider');
  }
  return context;
};
